module.exports = __webpack_public_path__ + "static/media/remove.8d2a9573.png";